import * as React from "react";
import { withRouter } from "react-router-dom";
import OldIcon from "@eave/shared/components/OldIcon";
import { Button } from "react-bootstrap";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";

const styles = require("./styles.module.scss");

interface HurdleEditorProps extends HurdleProps {
  history: any;
  children?: any;
}

const DefaultEditor: React.FunctionComponent = ({
  app,
  hurdle,
  onHide,
  history,
}: HurdleEditorProps) => {
  const handleClick = () => {
    history.goBack();
  };
  return (
    <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
      <pre>{JSON.stringify(hurdle, null, "\t")}</pre>
      <footer className={styles.footer}>
        <Button bsSize="small" onClick={handleClick}>
          <OldIcon type="thumb-up" size={16} />
          OK
        </Button>
      </footer>
    </HurdleView>
  );
};

export default withRouter(DefaultEditor);
